import { curry2, extend } from 'fxjs/es';

export const setTabData = curry2((key, data, tab) => {
  tab.tab_opt.__data__ = extend({}, tab.tab_opt.__data__, {
    [key]: data,
  });

  return tab;
});
